let auctionsComponent: ReturnType<typeof importAuctionsComponent> | undefined;

function importAuctionsComponent() {
  return import('./auctions.component').then((m) => m.AuctionsComponent);
}

export function loadAuctionsComponent() {
  auctionsComponent ??= importAuctionsComponent();
  return auctionsComponent;
}

export function preloadAuctionsComponent(): void {
  void loadAuctionsComponent();
}
